import { type App } from 'vue';

// Import the global options.
import { type AdminCompaniesGlobalOptions } from './options';
import { registerPartials } from '@precon-tools-suite-by-shared/vue-partials';

// Export the
export type { AdminCompaniesGlobalOptions };
export { default as routes } from './routes';

// Import/Export the components that you want to use outside of this library.
import InvitationBadge from './components/InvitationBadge.vue';

export { InvitationBadge };

// Import/Export the helpers that you want to use outside of this library.
import {
    Invitation,
    mockFetchInvitations,
    mockSendInvitation,
    mockFetchLicenses,
    License,
    mockAddLicense,
} from './helpers/mockData';

export {
    mockFetchInvitations,
    mockSendInvitation,
    mockFetchLicenses,
    mockAddLicense,
};

export type { Invitation, License };

// The definition of the plugin that installs the
export default {
    install(app: App) {
        registerPartials(
            app,
            {
                CompaniesCountPanel: () =>
                    import('./partials/CompaniesCountPanel.vue'),
                InvitationsCountPanel: () =>
                    import('./partials/InvitationsCountPanel.vue'),
                CreateCompany: () => import('./partials/CreateCompany.vue'),
                CompanyDetails: () => import('./partials/CompanyDetails.vue'),
                CompanyContacts: () => import('./partials/CompanyContacts.vue'),
                UpdateCompany: () => import('./partials/UpdateCompany.vue'),
                CompanyAddContact: () =>
                    import('./partials/CompanyAddContact.vue'),
                CompanyAssignContacts: () =>
                    import('./partials/CompanyAssignContacts.vue'),
                CompanyAssignTeams: () =>
                    import('./partials/CompanyAssignTeams.vue'),
                CompanyTeams: () => import('./partials/CompanyTeams.vue'),
                AddCompanyTeam: () => import('./partials/AddCompanyTeam.vue'),
            },
            '@precon-tools-suite-by-shared/admin-companies-feature/partials/'
        );
    },
};
